import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Col, Container } from 'react-bootstrap'
import clockImage from '../../assets/img/clock-White.gif'
import { useCountDown } from '../../Hooks/countDownHook'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { convertNumDouble } from '../../utils/helper'

function ClockTimer(props) {
    const { screen, isExpire, facilityData } = props
    const [days,hours,minutes] = useCountDown(screen)

    return (
        <div>
            {isExpire && <p className='text-primary ms-2 mb-0 pb-0'>Parking expires in</p>}
            <div className='bg-primary my-3 ps-4 mt-1'>
            <Container>
                <div className='d-flex'>
                    {/* <Col sm={3} xs={3} className='mt-3'><span style={{ height: '25px', width: '25px' }}>{getSvgIcon('hours_Clock' , '#ffffff')}</span></Col> <img src={clockImage} className='my-3' alt='clock' width='40%' height='auto' /> */}
                    <Col sm={3} xs={3}><span style={{ height: '25px', width: '25px' }}>
                            <img src={clockImage} className='my-3' alt='clock' width='40%' height='auto' />
                        </span></Col> 
                    <Col sm={9} xs={9} className='d-flex justify-content-between align-items-center text-light'>
                        {facilityData?.facility?.is_multiday_parking != '0' && <div className='d-flex flex-column text-center'>
                            <h6 className='m-0 p-0 fw-normal'>Days</h6>
                            <h4 className='m-0 p-0 fw-normal'>{days ? convertNumDouble(days) : '00'}</h4>
                        </div>}
                        {facilityData?.facility?.is_multiday_parking != '0' && <div className='d-flex flex-column text-center'>
                            <br />
                            <h2 className='fw-normal'>:</h2>
                        </div>}
                        <div className='d-flex flex-column text-center'>
                            <h6 className='m-0 p-0 fw-normal'>Hours</h6>
                            <h4 className='m-0 p-0 fw-normal'>{hours ? convertNumDouble(hours) : '00'}</h4>
                        </div>
                        <div className='d-flex flex-column text-center'>
                            <br />
                            <h2 className='fw-normal'>:</h2>
                        </div>
                        <div className='d-flex flex-column text-center'>
                            <h6 className='m-0 p-0 fw-normal'>Minutes</h6>
                            <h4 className='m-0 p-0 fw-normal'>{minutes ? convertNumDouble(minutes) : '00'}</h4>
                        </div>
                    </Col>
                </div>
            </Container>
        </div>
        </div>
       
    )
}

ClockTimer.propTypes = {
    dispatch: PropTypes.func,
    screen: PropTypes.string,
    isExpire: PropTypes.bool,
    facilityData: PropTypes.object,
}

ClockTimer.defaulProps = {
    dispatch: noop,
    screen: 'payment',
    isExpire: false,
    facilityData: EMPTY_OBJECT
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ClockTimer)